import { keyBy } from 'lodash';
import * as actionTypes from './actionTypes';

export function fetchConnection(payload) {
  return { type: actionTypes.FETCH_ONE, payload };
}
export function fetchConnectionSuccess(payload) {
  // console.log('payload', payload)
  const byId = { [payload.postUid]: payload };
  return { type: actionTypes.FETCH_ONE_SUCCESS, payload: { byId } };
}
export function fetchConnections(payload) {
  return { type: actionTypes.FETCH_COLLECTION, payload };
}
export function fetchConnectionsSuccess(paylaod) {
  // console.log('connection....', paylaod)
  // console.log('post...', posts, params)
  const byId = keyBy(paylaod, (con) => con.postUid);
  // console.log('byid....', byId)
  return { type: actionTypes.FETCH_COLLECTION_SUCCESS, payload: { byId } };
}
export function fetchHeaderImage(payload) {
  return { type: actionTypes.FETCH_HEADER_IMAGE, payload };
}
export function fetchHeaderImageSuccess(payload) {
  // console.log('header image...', payload)
  return { type: actionTypes.FETCH_HEADER_IMAGE_SUCCESS, payload };
}
export function getReadPosts(payload) {
  return { type: actionTypes.GET_READ_POSTS, payload }
}
export function getReadPostsSuccess(payload) {
  const byId = keyBy(payload, (read) => (read.posts_postUid));
  return { type: actionTypes.GET_READ_POSTS_SUCCESS, payload: { byId } }
}
export function saveReadPost(payload) {
  return { type: actionTypes.SAVE_READ_POST, payload }
}
export function saveReadPostSuccess(payload) {
  return { type: actionTypes.SAVE_READ_POST_SUCCESS, payload };
}

